/**
 * This directory contains utilities to support Web Component implementations
 * and should not be exported from this package.
 */
export * from './decorators';
export * from './has-own-property';
